
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs/api/link",
      function () {
        return require("private-next-pages/docs/api/link.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/docs/api/link"])
      });
    }
  